module.exports = __webpack_public_path__ + "static/img/weidu.5dce8522.png";